import {Row, Col, message} from 'antd';
import { useHistory } from 'react-router-dom';
import ExpertCard from '../ExpertCard';
import BaseTitle from '../BaseTitle';
import EmptyData from '../EmptyData';
import s from './index.module.css';
import {useEffect, useState} from "react";
import {getExpert} from "../../server/api";

const ExpertSection = ({ selectedModule }) => {
  const history = useHistory();
  const [experts, setExperts] = useState([]);

  useEffect(() => {
    if (selectedModule && selectedModule.code) {
      requestExperts();
    }
  }, [selectedModule])

  const requestExperts = async () => {
    let params = {
      pageSize: 4,
      pageNo: 1,
      category: selectedModule.code
    };
    getExpert(params)
        .then(function (res) {
          const { status, data: { result } } = res;
          if (status === 200) {
            setExperts(result.records);
            return;
          }
          message.error('查询数据出错，请刷新重试！');
        })
        .catch(function (error) {
        });
  }

  const expertData = [
    {
      id: 1,
      name: '专家1号',
      avatar: '/head.jpg', // 使用public目录下的头像图片
      description: '专业：检验检测方面的检验检测，技术指导',
      viewCount: 126,
      teamCount: 126
    },
    {
      id: 2,
      name: '专家2号',
      avatar: '/head.jpg',
      description: '专业：检验检测方面的检验检测，技术指导',
      viewCount: 126,
      teamCount: 126
    },
    {
      id: 3,
      name: '专家3号',
      avatar: '/head.jpg',
      description: '专业：检验检测方面的检验检测，技术指导',
      viewCount: 126,
      teamCount: 126
    },
    {
      id: 4,
      name: '专家4号',
      avatar: '/head.jpg',
      description: '专业：检验检测方面的检验检测，技术指导',
      viewCount: 126,
      teamCount: 126
    }
  ];

  const handleViewMore = () => {
    history.push('/experts');
  };

  return (
    <div className={s.expertSection}>
      <BaseTitle
          title={selectedModule?.modelTitle3}
          subtitle={selectedModule?.modelDesc3}
      />

      <Row gutter={[24, 24]} className={s.expertCards}>
        {experts && experts.length > 0 ? (
          experts.map((expert, index) => (
            <Col xs={24} sm={12} md={12} lg={6} key={`${index}-${expert?.expert?.id}`}>
              <ExpertCard
                expert={expert}
              />
            </Col>
          ))
        ) : (
          <Col span={24}>
            <EmptyData description="暂无专家数据" />
          </Col>
        )}
      </Row>

      {experts && experts.length > 0 && (
        <div className={s.expertMore}>
          <a href="#" className={s.moreLink} onClick={(e) => { e.preventDefault(); handleViewMore(); }}>查看更多</a>
        </div>
      )}
    </div>
  );
};

export default ExpertSection;
